import React from 'react';

const XML_EXAMPLE = `<?xml version="1.0" encoding="UTF-8"?> 
<recall lang="en" xmlns="urn:recall-schema">
  <edit_type>D</edit_type>
  <id>K18/CP/00039</id>
  <country_id>KR</country_id>
</recall>
`;

const TYPE = `<edit_type>D</edit_type>`;

const Example = () => {
  return (
    <div>
      <h4>Delete an existing recall</h4>
      <p className="pt-callout pt-intent-warning pt-icon-info-sign">
        <strong>Important:</strong> When deleting a recall, use the command <strong>{TYPE}</strong> in your XML file.
      </p>
      <pre>
        <code className="language-xml">
          {XML_EXAMPLE}
        </code>
      </pre>
    </div>
  )
};

export default Example;



// WEBPACK FOOTER //
// ./src/views/static/import-documentation/xml-format/xml-examples/example-delete.js